import http from '@/utils/http';

// 本地数据
export const fetchData = () => {
    return http({
        url: '/api/area/v2/userInfo/total',
        method: 'get',
        // params: query
    });
};


// 数据大屏get接口，通用方法
export const getDataByUrl = (url, params) => {
    return http({
        url: '/api/visualn/v2/index/' + url,
        method: 'get',
        params: params
    });
};